<!-- 企业中心 -->
<template>
  <div class="mine">
    <!-- 导航栏 -->
    <van-nav-bar title="企业中心" fixed placeholder z-index="10"></van-nav-bar>
    <!-- 背景 -->
    <div class="mine-info">
      <img src="@/assets/img/user/bgk.png" class="bgk" />
      <div class="mine-user">
        <img
          :src="userInfo==''?require('@/assets/img/home/user.png'):userInfo.logo"
          class="user-img"
        />
        <div class="mine-text">
          <p class="mine-company">{{userInfo.name}}</p>
          <div class="mine-name">{{userInfo.contact}}</div>
          <div class="mine-icon">
            <span>{{userInfo.nature_name}}</span>
            <span>{{userInfo.trade_name}}</span>
          </div>
        </div>
        <!-- <img src="@/assets/img/home/edit.png" class="edit" /> -->
      </div>
    </div>
    <div class="container">
      <!-- 面试管理 -->
      <div class="noun">面试管理</div>
      <div class="list">
        <div class="list-item" @click="navGo(1)">
          <span class="item-num">{{companyTotal}}</span>
          <span class="item-name">面试申请</span>
        </div>
        <div class="list-item" @click="navGo(2)">
          <span class="item-num">{{submitTotals}}</span>
          <span class="item-name">在招职业</span>
        </div>
        <div class="list-item" @click="navGo(3)">
          <span class="item-num">{{inviteTotals}}</span>
          <span class="item-name">已邀简历</span>
        </div>
      </div>
      <!--列表 -->
      <div class="item" v-for="(item, index) in tabList" :key="index" @click="go(index)">
        <div class="item-box">
          <img :src="item.icon" />
          <span>{{index==2?is_bind_wechat:item.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  logout,
  getCompanyDetail,
  queryPersonalInfo,
  wechatUnbind,
  wechatBind,
  companyApplyTotal,
  submitTotal,
  inviteTotal
} from "@/api/apiData";
import { Dialog, Toast } from "vant";
import { mapState, mapMutations } from "vuex";
import GetQueryString from "@/until/getParams";
export default {
  components: {},
  data() {
    return {
      tabList: [
        { name: "基本资料", icon: require("@/assets/img/home/icon-01.png") },
        { name: "收藏牛人", icon: require("@/assets/img/home/icon-02.png") },
        { name: "", icon: require("@/assets/img/home/icon-03.png") },
        { name: "退出登录", icon: require("@/assets/img/home/icon-04.png") }
      ],
      userInfo: "", //用户信息
      wechatNum: "",
      is_bind_wechat: "",
      companyTotal: 0,
      submitTotals: 0,
      inviteTotals: 0
    };
  },
  computed: {
    ...mapState(["token", "logins"])
  },
  methods: {
    ...mapMutations(["getToken", "refreshCode"]),
    // 路由跳转
    go(val) {
      switch (val) {
        case 0:
          // 基本资料
          this.$router.push({
            name: "Information",
            query: {
              type: 0
            }
          });
          break;
        case 1:
          // 面试管理
          this.$router.push({
            name: "interviewResult"
          });
          break;
        case 2:
          // 微信绑定
          this.wechat(this.wechatNum);
          break;
        case 3:
          //   this.sendMessage();
          // 退出登录
          Dialog.confirm({
            title: "退出登录",
            message: "确定退出登录吗"
          })
            .then(() => {
              logout({ token: this.mapState }).then(res => {
                // //(res);
                if (res.code == 1) {
                  Toast.success({
                    message: "退出成功",
                    forbidClick: true
                  });
                  this.getToken(["", ""]);
                  setTimeout(() => {
                    this.$router.replace({
                      name: "Index"
                    });
                  }, 2000);
                } else {
                  Toast(res.msg);
                }
              });
            })
            .catch(() => {});
          break;
      }
    },
    navGo(val) {
      switch (val) {
        case 1: //面试申请
          this.$router.replace({
            path: "/home/index"
          });
          break;
        case 2: //在招职业
          this.$router.replace({
            path: "/management"
          });
          break;
        case 3: //已邀简历
          this.$router.replace({
            path: "/home/index",
            query: {
              show: 1
            }
          });
          break;
      }
    },
    // 微信绑定
    wechat(wechatNum) {
      const that = this;
      if (wechatNum == 0) {
        //绑定
        that.refreshCode(2);
        var params = {
          appid: "wx0d3c07901732c258",
          redirect_uri:
            "https%3a%2f%2fncxtyjrwork.nccloudmedia.com%2fweb%2f%23%2fHomeBoss%2fhome%2fjobSearch",
          response_type: "code",
          scope: "snsapi_userinfo",
          state: 123456
        };
        window.location.href = `https://ncymkj.doudou00.com/get-weixin-code.html?appid=${params.appid}&redirect_uri=${params.redirect_uri}&response_type=${params.response_type}&scope=${params.scope}&state=${params.state}`;
      } else {
        //解绑

        Dialog.confirm({
          title: "提示",
          message: "确定将该账号与微信解绑吗？"
        })
          .then(() => {
            //(22);
            wechatUnbind({ token: that.token }).then(res => {
              //(res);
              if (res.code == 1) {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
                that.queryInfo();
              } else {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    // 查询
    queryInfo() {
      queryPersonalInfo({ token: this.token }).then(res => {
        // //(res);
        if (res.code == 1) {
          if (res.data.is_bind_wechat == 0) {
            this.is_bind_wechat = "微信绑定";
            if (GetQueryString("code")) {
              if (this.logins == 2) {
                wechatBind({
                  token: this.token,
                  code: GetQueryString("code")
                }).then(res => {
                  // //(res);
                  if (res.code == 1) {
                    Toast.success({
                      forbidClick: true,
                      message: res.msg
                    });
                    this.refreshCode(1);
                    this.queryInfo();
                  } else {
                    this.refreshCode(1);
                    Toast.fail({
                      forbidClick: true,
                      message: res.msg
                    });
                  }
                });
              }
            }
          } else {
            this.is_bind_wechat = "解绑微信";
          }
          this.wechatNum = res.data.is_bind_wechat;
        }
      });
    },
    // 获取初始值
    getInstall() {
      const that = this;
      let { token, companyTotal, submitTotals } = that;
      let obj = {
        token: token
      };
      getCompanyDetail(obj).then(res => {
        if (res.code == 1) {
          this.userInfo = res.data;
        }
      });
      //   获取企业职位发布数量
      submitTotal(obj).then(res => {
        if (res.code == 1) {
          that.submitTotals = res.data.total;
        }
      });
      //   获取职位申请的数量
      companyApplyTotal(obj).then(res => {
        if (res.code == 1) {
          that.companyTotal = res.data.total;
        }
      });
      // 获取邀请的数量
      inviteTotal(obj).then(res => {
        if (res.code == 1) {
          that.inviteTotals = res.data.total;
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getInstall();
    this.queryInfo();
  }
};
</script>
<style lang='less' scoped>
.mine {
  .mine-info {
    position: relative;
    top: 0;
    padding: 0 0.3rem;
    .bgk {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 2.4rem;
    }
    .mine-user {
      position: relative;
      display: flex;
      padding: 0.3rem;
      border-radius: 0.08rem;
      background: #fff;
      font-size: 0.2rem;
      top: 1rem;
      box-shadow: 0 0 0.1rem rgba(21, 21, 21, 0.3);
      .edit {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
      }
      .user-img {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 50%;
      }
      .mine-text {
        margin-left: 0.3rem;
        .mine-company {
          font-size: 0.32rem;
          font-weight: bold;
          line-height: 1.5;
          color: #333333;
        }
        .mine-name {
          font-size: 0.24rem;
          font-weight: 500;
          line-height: 1.5;
          color: #333333;
          margin: 0.1rem 0;
        }
        .mine-icon {
          font-size: 0.24remf;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          span {
            padding: 0.05rem 0.1rem;
            border-radius: 0.05rem;
            margin-right: 0.3rem;
          }
          span:first-child {
            background: #ff6f1c;
          }
          span:nth-child(2) {
            background: #1c9cff;
          }
        }
      }
    }
  }
  .container {
    margin-top: 1.8rem;
    padding: 0 0.3rem;
    // 面试管理
    .noun {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: bold;
      color: #333333;
    }
    .noun::before {
      content: "";
      width: 0.05rem;
      height: 0.3rem;
      background: #ff4343;
      border-radius: 0.05rem;
      margin-right: 0.2rem;
    }
    //面试数量
    .list {
      display: flex;
      padding: 0.24rem;
      border: 1px solid #f8f8f8;
      border-left: 0;
      border-right: 0;
      margin-top: 0.35rem;
      .list-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        color: #333333;
        .item-num {
          font-size: 0.5rem;
          font-weight: bold;
        }
        .item-name {
          font-size: 0.3rem;
          font-weight: 550;
          margin-top: 0.3rem;
        }
      }
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.3rem 0;
      border-bottom: 1px solid #f8f8f8;
      .item-box {
        display: flex;
        align-items: center;
        img {
          width: 0.32rem;
          height: 0.28rem;
          margin-right: 0.2rem;
        }
        span {
          font-size: 0.28rem;
          font-weight: bold;
          color: #333333;
        }
      }
    }
    .item::after {
      content: "";
      border-top: 2px solid #dcdbdb;
      border-right: 2px solid #dcdbdb;
      transform: rotate(45deg);
      width: 0.2rem;
      height: 0.2rem;
    }
  }
}
</style>